import { useEffect, useMemo } from 'react'
import { values } from 'lodash'
import { useNavigate, useParams } from 'react-router-dom'

import {
  getClientDataWithGuid,
  getDataWithBackofficeGuid,
  getDataWithGuid,
} from '@/api/commercialCombined'
import { resetEverything } from '@/utils/Clean'
import {
  brokerDetailStore,
  brokerGuidStore,
  clientStore,
  commercialCombinedFormStore,
  isBackofficeStore,
  isMTAStore,
} from '@/store/CommercialCombinedFormStore'
import { BrokerBuyRouter } from '@/router/brokerBuyRouter'
import { CommercialCombinedGuidConverter } from '@/managers/CommercialCombinedGuidConvert'

export const backOfficeUrl = '/back-office'
export const brokerUrl = '/broker'

const CommercialCombined = () => {
  const navigate = useNavigate()
  const { guid: paramsGuid, brokerId, brokerName, clientId } = useParams()

  const { setData } = commercialCombinedFormStore()
  const { setGuid } = brokerGuidStore()
  const { setClient } = clientStore()
  const { setBroker } = brokerDetailStore()
  const { setBackoffice } = isBackofficeStore()
  const { setMta } = isMTAStore()

  const pathname = document.referrer
  const isRisk = pathname.includes('risks')
  const guid = isRisk
    ? pathname.substring(pathname.lastIndexOf('/') + 1)
    : paramsGuid
  const isBackOffice = useMemo(
    () => pathname.includes(`${backOfficeUrl}/`),
    [pathname]
  )

  const isBroker = useMemo(() => pathname.includes(`${brokerUrl}/`), [pathname])

  const urlPrefix = useMemo(() => {
    setBackoffice(!!isBackOffice)
    return isBackOffice ? `${backOfficeUrl}/` : isBroker ? `${brokerUrl}/` : '/'
  }, [isBackOffice, isBroker])

  const isMta =
    pathname.toLowerCase().startsWith(`${urlPrefix}buy/`) && guid != null

  useEffect(() => {
    setClient(clientId)
    setGuid(guid)
    setBroker({
      brokerName: brokerName,
      brokerId: brokerId,
    })
    setMta(isMta)

    if (clientId) {
      if (guid) {
        getDataWithBackofficeGuid(guid)
          .then((res) => {
            const convertedObj = values(res.data)
            setData(CommercialCombinedGuidConverter(convertedObj))
          })
          .catch((reason) => {
            console.log(reason)
            resetEverything()
          })
          .finally(() => {
            navigate(BrokerBuyRouter.step1.href, {
              state: { from: 'commercialCombined' },
            })
          })

        return
      }
      getClientDataWithGuid(clientId)
        .then((res) => {
          const convertedObj = values(res.data)
          setData(CommercialCombinedGuidConverter(convertedObj))
        })
        .catch((reason) => {
          console.log(reason)
          resetEverything()
        })
        .finally(() => {
          navigate(BrokerBuyRouter.step1.href, {
            state: { from: 'commercialCombined' },
          })
        })

      return
    }

    if (guid) {
      // backoffice + guid
      if (isBackOffice) {
        getDataWithBackofficeGuid(guid)
          .then((res) => {
            setGuid(guid)
            const convertedObj = values(res.data)
            setData(CommercialCombinedGuidConverter(convertedObj))
          })
          .finally(() => {
            navigate(BrokerBuyRouter.step1.href, {
              state: { from: 'commercialCombined' },
            })
          })
        return
      }

      // just guid
      getDataWithGuid(guid)
        .then((res) => {
          setGuid(guid)
          const convertedObj = values(res.data)
          setData(CommercialCombinedGuidConverter(convertedObj))
        })
        .finally(() => {
          navigate(BrokerBuyRouter.step1.href, {
            state: { from: 'commercialCombined' },
          })
        })
    } else {
      navigate(BrokerBuyRouter.step1.href)
    }
  }, [])

  return <div>Retrieving data...</div>
}

export default CommercialCombined
